<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 12:02:05
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 15:44:46
 * @FilePath: \zhucai_user\src\pages\member\child\info.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div v-loading="isloading" class="my-container">
    <div class="my-title">我的证书</div>
    <div class="my-content">
      <el-form
        ref="form"
        :model="form"
        class="sub-form"
        inline
        style="margin-top: 20px"
      >
        <el-form-item label="手机号码：" prop="Phone">
          <el-input
            v-model="form.Phone"
            disabled
            placeholder="请输入手机号码"
          />
        </el-form-item>
        <el-form-item label="毕业学校：" prop="School">
          <el-input
            v-model="form.School"
            disabled
            placeholder="请输入毕业学校"
          />
        </el-form-item>
        <el-form-item label="姓名：" prop="RealName">
          <el-input v-model="form.RealName" disabled placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="专业名称：" prop="Majors">
          <el-input
            v-model="form.Majors"
            disabled
            placeholder="请输入专业名称"
          />
        </el-form-item>
        <el-form-item label="身份证号：" prop="IDCard">
          <el-input
            v-model="form.IDCard"
            disabled
            placeholder="请输入身份证号"
          />
        </el-form-item>
        <el-form-item label="学历：" prop="Education">
          <el-input
            v-model="form.Education"
            disabled
            placeholder="请输入学历"
          />
        </el-form-item>
        <el-form-item label="职务：" prop="PostName">
          <el-input v-model="form.PostName" disabled placeholder="请输入职务" />
        </el-form-item>
        <el-form-item label="生源地：" prop="OriginAddress">
          <el-input
            v-model="form.OriginAddress"
            disabled
            placeholder="请输入生源地"
          />
        </el-form-item>
        <el-form-item label="参加工作时间：">
          <el-date-picker
            v-model="form.WorkYears"
            value-format="yyyy-MM-dd"
            type="date"
            disabled
            class="riqi"
            placeholder="请选择日期"
            style="margin-top: 1px"
          />
        </el-form-item>
        <br />
        <el-form-item label="考试是否通过：">
          <el-radio-group v-model="form.IsPassExam" disabled>
            <el-radio :label="true"> 是 </el-radio>
            <el-radio :label="false"> 否 </el-radio>
          </el-radio-group>
        </el-form-item>
        <br />
        <div class="zhengshu">
          <span class="el-form-item__label">选择证书：</span>
          <el-input
            v-model="form.ClassifyName"
            disabled
            placeholder="证书类型"
          />
          <el-input v-model="form.CertName" disabled placeholder="证书分类" />
          <el-input v-model="form.CertLevel" disabled placeholder="证书级别" />
        </div>

        <br />
        <el-form-item label="是否继续教育：">
          <span> {{ form.IsContinuingEducation === false ? "否" : "是" }}</span>
        </el-form-item>
        <br />
        <el-form-item label="证书有效期：">
          <span>
            {{
              form.ValidityYear === 0 ? "永久" : `${form.ValidityYear}年`
            }}</span
          >
        </el-form-item>
        <br />
        <el-form-item label="证书图片：">
          <img
            v-if="form.ImgPath"
            :src="form.ImgPath"
            :onerror="userError"
            class="img"
          />
        </el-form-item>
        <br />
        <el-form-item label="证书编号：">
          <el-input
            v-model="form.CertNo"
            disabled
            placeholder="请输入您的单位名称"
            class="width754"
          /> </el-form-item
        ><br />
        <el-form-item label="单位名称：">
          <el-input
            v-model="form.CompanyName"
            disabled
            placeholder="请输入您的单位名称"
            class="width754"
          /> </el-form-item
        ><br />
        <el-form-item label="报名渠道：">
          <el-input
            v-model="form.SignWay"
            disabled
            placeholder="请输入您的报名渠道"
            class="width754"
          /> </el-form-item
        ><br />
        <el-form-item label="收货地址：">
          <el-input
            v-model="form.DeliveryAddress"
            disabled
            placeholder="请输入您的收货地址"
            class="width754"
          />
        </el-form-item>

        <el-form-item label=" ">
          <el-button class="submit-btn" @click="back"> 返回 </el-button>
          <el-button class="submit-btn" @click="feedback"> 反馈 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <freebackDialog ref="dialog" :id="id" @closePop="close"></freebackDialog>
  </div>
</template>

<script>
import freebackDialog from "./child/freebackDialog";
import { GetMyCertDetail } from "@/api/member";

/* eslint-disable */
export default {
  name: "certDetail",
  components: {
    freebackDialog,
  },
  data() {
    return {
      id: 0,
      isloading: true,
      form: {},
    };
  },

  mounted() {
    this.getInfo();
  },

  methods: {
    close() {
      this.getInfo();
    },
    feedback() {
      this.$refs.dialog.open();
    },
    back() {
      this.$router.push({ path: "/member/cert" });
    },

    getInfo() {
      this.isloading = true;
      GetMyCertDetail({
        CertID: this.$route.query.CertID,
      })
        .then((res) => {
          this.isloading = false;
          this.id = res.data.CertID;
          this.form = { ...this.form, ...res.data };
        })
        .catch(() => {
          this.isloading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.sub-form {
  width: 900px;
  ::v-deep .el-input__inner {
    width: 300px;
    height: 46px;
    font-size: 16px;
  }
  ::v-deep .el-form-item__label {
    width: 130px;
  }
  .zhengshu {
    width: 1200px;
    .el-input {
      display: inline;
      margin-right: 20px;
    }
  }
  .img {
    width: 300px;
    height: 225px;
    border-radius: 6px;
    border: 1px solid #e6e6e6;
  }
  ::v-deep .el-input.is-disabled .el-input__inner {
    background: #ffffff;
    font-size: 16px;
    color: #333333;
  }
  .width754 {
    ::v-deep .el-input__inner {
      width: 754px;
    }
  }
}
//修改选中radio背景色、边框
//点击前的样式
::v-deep .el-input__inner {
  width: 300px;
  height: 46px;
}
::v-deep .el-radio__label {
  font-size: 16px;
}
::v-deep .el-radio__inner {
  border-radius: 50%;
  width: 26px;
  height: 26px;
}
//点击后的样式
::v-deep .el-radio__inner::after {
  width: 26px;
  height: 26px;
  //让圆框变成方框
  border-radius: 50%;
  //点击后方框中的图片
  background: url("~@/assets/img/home/61.png") no-repeat;
  background-size: 100% 100%;
  border: none;
  //图片适应方式
  ///background-size：contain，
  //background-size:150px 80px;
  //background-size:cover;
  //background-size:40% 60%;
}

.submit-btn {
  width: 144px;
  height: 52px;
  background: #1d79ff;
  border-radius: 6px;
  font-size: 18px;
  color: #ffffff;
}
.applyOrg-btn {
  width: 200px;
  height: 46px;
  margin-left: 10px;
  background: #1d79ff;
  border-radius: 6px;
  font-size: 16px;
  color: #ffffff;
}
</style>
